export default __webpack_public_path__ + "static/CF_Cover-b0cd53f9fb19d285feedbb48e2d41edc.png";